import { API, Auth, Hub } from "aws-amplify";
import { Helmet } from "react-helmet";
import React, { lazy, useState, Suspense, useEffect } from "react";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { Navigate, Route, Routes } from "react-router-dom";
import { AppDispatch, RootState } from "../app/store";
import {
  login,
  logout,
  PlayerMode,
  selectPlayer,
  setPlayerMode,
  updateAccount,
} from "../features/player/playerSlice";
import NotFound from "./404";
import { useNavigate } from "react-router-dom";
import "../scss/welcome2.scss";

import Loading from "../components/shared-components/Loading";
import { ConfigProvider } from "antd";

import PlayPGVirtual from "../components/games/PlayPGVirtual";
import PlaySRVirtual from "../components/games/PlaySRVirtual";
import Kiosk from "../components/games/Kiosk";
import WelcomeLayout2 from "../layouts/WelcomeLayout2";
import { IntlProvider } from "react-intl";
import AppLocale from "../lang";
import { AntdLocale } from "../lang";
import {
  Localization,
  selectTheme,
  setMode,
  setShowBackgroudImage,
  showLoginPopup,
  ThemeMode,
} from "../features/theme/themeSlice";
import MessagesForm from "./account/MessagesForm";
import moment from "moment";
import * as subscriptions from "../graphql/subscriptions";
import { GRAPHQL_AUTH_MODE } from "@aws-amplify/api-graphql";
import ShowPage from "../components/ShowPage";

import { useLocation, useParams } from "react-router";

import PlayTimelessTech from "../components/games/PlayTimelesstech";

import CasinoLayout from "../layouts/CasinoLayout";
import PlayTimelessTechCasino from "../components/games/PlayTimelesstechCasino";
import KioskLayout from "../layouts/KioskLayout";
import Sport from "./welcome/sport";
import Sport2 from "./welcome/sport2";
import SportLive from "./welcome/sportlive";
import Horseracing from "./welcome/horseracing";
import Poker from "./welcome/poker";
import Pokertest from "./welcome/pokertest";
import CasinoMobileLayout from "../layouts/CasinoMobileLayout";
import useAccount from "../hooks/useAccount";
import Nascosti from "./welcome/nascosti";
import PlayNascosti from "../components/games/PlayNascosti";
import KioskAdminLayout from "../layouts/KioskLayoutAdmin";
import CashBettingsList from "./kioskadmin/components/CashBettingsList";
import CashMovementLists from "./kioskadmin/components/CashMovements/CashMovementLists";

moment.locale("it-IT");
const WelcomeLayout = lazy(() => import("../layouts/WelcomeLayout"));
const PlayerLayout = lazy(() => import("../layouts/PlayerLayout"));
const Home = lazy(() => import("../views/welcome/home"));
const Virtuali = lazy(() => import("../views/welcome/virtuali"));
const Casino = lazy(() => import("../views/welcome/casino"));
const LiveCasino = lazy(() => import("../views/welcome/livecasino"));
const Lottery = lazy(() => import("../views/welcome/lottery"));
const Skillgames = lazy(() => import("../views/welcome/skillgames"));
const Register = lazy(() => import("../views/register/Register"));
const PlayerHome = lazy(() => import("../views/player/PlayerHome"));
const AccountHome = lazy(() => import("../views/account/AccountHome"));
const Movements = lazy(() => import("../views/kioskadmin/Movements"));
const Bettings = lazy(() => import("../views/kioskadmin/Bettings"));

const AccountWithdrawalForm = lazy(
  () => import("./account/AccountWithdrawalForm")
);
const MovementsList = lazy(() => import("./account/MovementsList"));
const MovementsListDetail = lazy(
  () => import("./account/components/MovementsListDetail")
);
const PersonaDataAccountForm = lazy(
  () => import("./account/PersonalDataAccountForm")
);
const VerifyAccountForm = lazy(() => import("./account/VerifyAccountForm"));
const AccountDepositForm = lazy(() => import("./account/AccountDepositForm"));

export const Views: React.FC = () => {
  let s: any = null;
  const navigate = useNavigate();
  const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
  const player = useAppSelector(selectPlayer);
  const params = useLocation();
  const [kioskModeL, setKioskModeL] = useState<boolean>(false);
  const theme = useAppSelector(selectTheme);
  const dispatch = useDispatch<AppDispatch>();
  const [ready, setReady] = useState(false);
  const locale: Localization = theme.language as any;
  const currentAppLocale = AppLocale[locale];

  const { accountBalance, withdrawable } = useAccount();
  // console.log(accountBalance, withdrawable);

  useEffect(() => {
    console.log(player.mode, theme.mode);
  }, [player.mode]);

  const checkSession = async () => {
    console.log("check session");
    let sessionOk = null;
    try {
      sessionOk = await Auth.currentAuthenticatedUser();
      if (sessionOk.username) {
        setReady(true);
        const groups =
          sessionOk.signInUserSession.accessToken.payload["cognito:groups"];
        dispatch(
          login({ logged: true, username: sessionOk.username, groups: groups })
        );

        if (theme.mode !== ThemeMode.KIOSKADMIN) {
          if (groups.indexOf("kiosks") > -1 && theme.mode === ThemeMode.KIOSK) {
            //  dispatch(setPlayerMode(PlayerMode.KIOSK));
            dispatch(setShowBackgroudImage(true));
          } else {
            // console.log("cambie")
            // dispatch(setPlayerMode(PlayerMode.DEFAULT));
          }
        }

        if (s === null) {
          const subscription = API.graphql({
            query: subscriptions.updateAccount,
            authMode: GRAPHQL_AUTH_MODE.API_KEY,
            variables: { PK: "USER#" + sessionOk.username },
          });

          if ("subscribe" in subscription) {
            s = subscription.subscribe({
              next: (event: any) => {
                dispatch(updateAccount(event.value.data.updateAccount));
              },
              error: (error: any) => {},
            });
          }
        }
      }
      return sessionOk;
    } catch (e) {
      console.log(e);
      if (player.mode === PlayerMode.KIOSK || theme.mode === ThemeMode.KIOSK) {
        setTimeout(() => {
          dispatch(showLoginPopup(true));
        }, 400);
      }

      return sessionOk;
    }

    //if (session) navigate('/play');
  };

  useEffect(() => {
    const kiosk = localStorage.getItem("kiosk");

    if (theme.mode !== ThemeMode.KIOSKADMIN) {
      (async () => {
        const s = await checkSession();

        if (s === null && (theme.mode === ThemeMode.KIOSK || kiosk !== null)) {
          dispatch(showLoginPopup(true));
        } else {
          dispatch(showLoginPopup(false));
        }
      })();

      if (
        (theme.mode === ThemeMode.KIOSK || kiosk !== null) &&
        player.mode !== PlayerMode.KIOSK
      ) {
        //  dispatch(setPlayerMode(PlayerMode.KIOSK));
      }

      return () => {
        s.unsubscribe();
      };
    }
  }, []);

  return (
    <>
      <ConfigProvider locale={AntdLocale[locale]}>
        <IntlProvider locale={theme.language} messages={currentAppLocale}>
          <Suspense fallback={<Loading />}>
            <Routes>
              <Route
                element={
                  theme.isMobile ? <CasinoMobileLayout /> : <CasinoLayout />
                }
              >
                <Route path="playcasino" element={<PlayTimelessTechCasino />} />
              </Route>
              {theme.mode === ThemeMode.KIOSK && (
                <Route element={<KioskLayout />}>
                  <Route path="/" element={<Home />} />
                </Route>
              )}
              {theme.mode === ThemeMode.KIOSKADMIN && (
                <Route element={<KioskAdminLayout />}>
                  <Route path="/" element={<CashBettingsList />} />
                  <Route path="kioskadmin">
                    <Route path="movimenti" element={<Movements />} />
                    <Route path="scommesse" element={<Bettings />} />
                    <Route path="exit" element={<Home />} />
                  </Route>
                </Route>
              )}
              {theme.mode === ThemeMode.DEFAULT && (
                <Route element={<WelcomeLayout2 />}>
                  <Route path="/" element={<Home />} />
                </Route>
              )}
              <Route element={<WelcomeLayout2 />}>
                <Route path="welcome" element={<Virtuali />} />
                <Route path="virtual">
                  <Route index element={<Virtuali />} />
                  <Route path=":subcategory" element={<Virtuali />} />
                </Route>

                {player.username === "kiosk1@shop1" && (
                  <Route path="sport" element={<Sport2 />} />
                )}
                {player.username === "kiosk1@shop1" && (
                  <Route path="sportlive" element={<Sport2 />} />
                )}

                {player.username !== "kiosk1@shop1" && (
                  <Route path="sport" element={<Sport />} />
                )}
                {player.username !== "kiosk1@shop1" && (
                  <Route path="sportlive" element={<SportLive />} />
                )}

                <Route path="casino">
                  <Route index element={<Casino />} />
                  <Route path=":subcategory" element={<Casino />} />
                </Route>
                <Route path="poker">
                  <Route index element={<Poker />} />
                  <Route path=":subcategory" element={<Poker />} />
                </Route>
                <Route path="pokertest">
                  <Route index element={<Pokertest />} />
                  <Route path=":subcategory" element={<Pokertest />} />
                </Route>
                <Route path="live-casino">
                  <Route index element={<LiveCasino />} />
                  <Route path=":subcategory" element={<LiveCasino />} />
                </Route>
                <Route path="lottery">
                  <Route index element={<Lottery />} />
                  <Route path=":subcategory" element={<Lottery />} />
                </Route>
                <Route path="playnascosti">
                  <Route index element={<PlayNascosti />} />
                  <Route path=":subcategory" element={<PlayNascosti />} />
                </Route>
                <Route path="horseracing">
                  <Route index element={<Horseracing />} />
                  <Route path=":subcategory" element={<Horseracing />} />
                </Route>
                <Route path="poker">
                  <Route index element={<Poker />} />
                  <Route path=":subcategory" element={<Poker />} />
                </Route>
                <Route path="skillgames">
                  <Route index element={<Skillgames />} />
                  <Route path=":subcategory" element={<Skillgames />} />
                </Route>

                <Route path="playpgvirtual" element={<PlayPGVirtual />} />
                <Route path="playsrvirtual" element={<PlaySRVirtual />} />
                <Route path="playtmless" element={<PlayTimelessTech />} />
                <Route path="page/:pagename" element={<ShowPage />} />
                <Route path="kiosk" element={<Kiosk />} />
                {player.logged && (
                  <>
                    <Route path="home" element={<Virtuali />} />
                    <Route path="nascosti" element={<Nascosti />} />
                    <Route path="account" element={<AccountHome />}>
                      <Route
                        path="/account/personal-data"
                        element={<PersonaDataAccountForm />}
                      />
                      <Route
                        path="/account/verify-account"
                        element={<VerifyAccountForm />}
                      />
                      <Route
                        path="/account/deposit"
                        element={<AccountDepositForm />}
                      />
                      <Route
                        path="/account/withdrawal"
                        element={<AccountWithdrawalForm />}
                      />

                      <Route
                        path="/account/messages"
                        element={<MessagesForm />}
                      />
                        <Route
                      path="/account/movements-list"
                      element={<MovementsList />}
                    />
                    <Route
                      path="/account/balance"
                      element={<MovementsList />}
                    />
                     <Route
                      path="/account/pendingwithdrawals"
                      element={<MovementsList pendingWithdrawal />}
                    />
                      <Route
                      path="/account/movements-list/:pk"
                      element={<MovementsListDetail />}
                    />
                    </Route>
                  
                   
                  
                  </>
                )}
                {!player.logged && (
                  <Route path="/home" element={<Navigate to="/" />}>
                    {/* <Route path="" element={<PlayerHome />} /> */}
                  </Route>
                )}
              </Route>
              <Route path="loading" element={<Loading />} />
              <Route path="register" element={<Register />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </IntlProvider>
      </ConfigProvider>
    </>
  );
};
